import { render, staticRenderFns } from "./DashboardUsageSplit.vue?vue&type=template&id=fb1b9d54&scoped=true"
import script from "./DashboardUsageSplit.vue?vue&type=script&lang=js"
export * from "./DashboardUsageSplit.vue?vue&type=script&lang=js"
import style0 from "./DashboardUsageSplit.vue?vue&type=style&index=0&id=fb1b9d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1b9d54",
  null
  
)

export default component.exports